<template>
  <div id="app" @mousemove="mouseMoveEvent" @click="mouseMoveEvent">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: "App",

  provide() {
    return {
      reload: this.reload,
    };
  },
  data() {
    return {
      isRouterAlive: true,
      timmer: null,
    };
  },
  methods: {
    //然后在需要刷新的页面引入依赖：inject: ['reload'], 在需要执行的地方直接调用方法即可：this.reload()。
    // 在单独页面监听，刷新时调用this.reload()，路由不换，页面内容空白
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(() => {
        this.isRouterAlive = true;
      });
    },

    mouseMoveEvent(){
      let path = ['/login']
      if(!path.includes(this.$route.path)) { //如果不是登录页面的话,页面停止操作30分钟后清空session
        clearTimeout(this.timmer);
        this.init();
      }
    },
    init(){
      this.timmer=setTimeout(()=>{
        //清除session
        sessionStorage.removeItem("sessionData");
        sessionStorage.clear();
        //清除缓存
        localStorage.removeItem('api_token')
        localStorage.removeItem('powers')
        //跳往登录页面
        this.$router.push({
          path: "/login",
        });
      },30*60*5000);//设置半小时清空session进入登录页
    },


  }
};
</script>

<style>

@charset "utf-8";
/* CSS Document */
/*golbal*/
@media screen and (min-width:360px){#tankuang{width:1000px}}
body {
  font-family: "Tahoma";
  font-size: 14px;
  font-style: normal;
  margin: 0;
  padding: 0;
  overflow: hidden;

}
*{margin:0px;padding:0px;}
* {
  -webkit-box-sizing: border-box;
     -moz-box-sizing: border-box;
          box-sizing: border-box;
}
*:before,
*:after {
  -webkit-box-sizing: border-box;
     -moz-box-sizing: border-box;
          box-sizing: border-box;
}
ul, menu, dir {
    display: block;
    list-style-type: disc;
    -webkit-margin-before: 0;
    -webkit-margin-after: 0;
    -webkit-margin-start: 0;
    -webkit-margin-end: 0;
    -webkit-padding-start: 0;
}
::-webkit-scrollbar{
display:none;
}
ul,
ol,
dl,
dt,
dd,
li {
  margin: 0;
  padding: 0;
  list-style: none;
}
h1,
h2,
h3 {
  margin: 0;
  padding: 0;
}
img {
  border: 0;
}
a {
  text-decoration: none;
}
.clr {
  clear: both;
}
.fleft {
  float: left;
}
.fright {
  float: right;
}
.hid {
  display: none;
}
.showdiv {
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/App.vue